import * as React from "react";
import { joinReactNodes, pubmedLink } from "../../../utils/toolsReact";
import { Publication } from "../../../api/openapi-generator";

interface Props {
  publications: string[],
  allPublications: Record<string, Publication>,
}

function PublicationParagraph({publications, allPublications}: Props) {
  if (publications === null || publications.length === 0) {
    return null;
  }
  return (
    <p>Publications: {joinReactNodes(
      publications.map(pubmed => allPublications[pubmed])
        .filter(pub => pub !== undefined)
        .map(pub => (
          <span>
            PubMed:{pubmedLink(pub.pubmed)}
          </span>
        ))
    )}.</p>
  )
}

export default PublicationParagraph;
